import { RosterImportStrategy } from './types';
import { TourPlayPdfParser } from './tourplayPdf';

class RosterImportRegistry {
  private strategies = new Map<string, RosterImportStrategy>();

  public register(strategy: RosterImportStrategy): void {
    this.strategies.set(strategy.id, strategy);
  }

  public getStrategies(): RosterImportStrategy[] {
    return Array.from(this.strategies.values());
  }

  public getStrategy(id: string): RosterImportStrategy | undefined {
    return this.strategies.get(id);
  }
}

export const rosterImportRegistry = new RosterImportRegistry();

// Register concrete strategies by default
rosterImportRegistry.register(new TourPlayPdfParser());
